import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';

// Notetaker toggle styles
// Color constants

const toggleContainerTogglePositionOnCss = "tyalzjl";
const toggleContainerToggleDisabledCss = "t1p4lvn5";
const toggleContainerShowErrorStateCss = "t1gu0k3t";

/**
 * Styled toggle button component that serves as the main container for the notetaker toggle.
 * Handles different visual states: on/off, hover, disabled, and error states.
 * Includes accessibility attributes for switch role.
 */
const toggleContainerCss = "t1w917ft";
export const ToggleContainer = forwardRef((props, ref) => {
  const {
    togglePositionOn,
    toggleDisabled,
    showErrorState,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(toggleContainerCss, {
    [toggleContainerTogglePositionOnCss]: togglePositionOn,
    [toggleContainerToggleDisabledCss]: toggleDisabled,
    [toggleContainerShowErrorStateCss]: showErrorState
  }, props.className)} />;
});
const toggleHandleToggleDisabledCss = "tyma2ac";
const toggleHandleTogglePositionOnCss = "twul8m6";
const toggleHandleIsSpotlightCss = "t1men1as";
const toggleHandleCss = "tx19o8q";
export const ToggleHandle = forwardRef((props, ref) => {
  const {
    toggleDisabled,
    togglePositionOn,
    isSpotlight,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(toggleHandleCss, {
    [toggleHandleToggleDisabledCss]: toggleDisabled,
    [toggleHandleTogglePositionOnCss]: togglePositionOn,
    [toggleHandleIsSpotlightCss]: isSpotlight
  }, props.className)} />;
});
const toggleTextToggleDisabledCss = "ttorngb";
const toggleTextTogglePositionOnCss = "to8fzdl";
const toggleTextCss = "t1x1qic8";
export const ToggleText = forwardRef((props, ref) => {
  const {
    toggleDisabled,
    togglePositionOn,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(toggleTextCss, {
    [toggleTextToggleDisabledCss]: toggleDisabled,
    [toggleTextTogglePositionOnCss]: togglePositionOn
  }, props.className)} />;
});
const wrapperCss = "w1ah8pe3";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const toggleIconTogglePositionOnCss = "t12vq82i";
const toggleIconCss = "t19xq7x7";
export const ToggleIcon = forwardRef((props, ref) => {
  const {
    togglePositionOn,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(toggleIconCss, {
    [toggleIconTogglePositionOnCss]: togglePositionOn
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");